import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {


    constructor(private _http: HttpClient) {
    }

    public postImproper(program: any) {
        return this._http.post<any>(`${environment.apiUrl}/dashboard/improper`, {program});
    }

    public postRiskAnalysis(program: number) {
        return this._http.post<any>(`${environment.apiUrl}/dashboard/category`, {program});
    }

    public postProgramList() {
        return this._http.get<any>(`${environment.apiUrl}/programs?no_limit`, {});
    }

    public getModal(id: number) {
        return this._http.get<any>(`${environment.apiUrl}/dashboard/modal/${id}`);
    }

    public postRecommendation(limit: number, important: number, pricing: number, category: number, difficulty: number, type: number, status_id: boolean) {
        return this._http.post<any>(`${environment.apiUrl}/dashboard/remedial`, {limit, important, pricing, category, difficulty, type, status_id});
    }

    public postActionType(program: any) {
        return this._http.post<any>(`${environment.apiUrl}/dashboard/actiontype`, {program});
    }

    public postCyberScore(program: any) {
        return this._http.post<any>(`${environment.apiUrl}/dashboard/cyberscore`, {program});
    }
}
